import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl } from 'react-intl';
import GlobalFieldList from './GlobalFieldList';
import { CREATE_GLOBAL_ARI } from '../mutations';
import { withAccount } from '../../../../components/AccountContext';
import CreateTextField from './CreateTextField';
import CreateNumberField from './CreateNumberField';
import CreateDropdownField from './CreateDropdownField';
import messages from '../intl-messages';


const CreateGlobalARIFields = ({
  maxFieldCount, currentFieldCount, currentAccount, ariTypeOptions, data, intl: { formatMessage },
}) => {
  const [ariType, setAriType] = useState('');

  const [addGlobalAriField] = useMutation(CREATE_GLOBAL_ARI, { refetchQueries: ['getAccount'] });

  return (
    <div style={{ marginBottom: '10px', width: '100%' }}>
      <Panel
        className="p-col-12 sub-panel"
        header={`${formatMessage(messages.globalCreatePanelHeader)} (${currentFieldCount}/${maxFieldCount})`}
      >
        <div style={{ marginBottom: '10px' }}>
          <GlobalFieldList data={data} />
        </div>

        {currentFieldCount < maxFieldCount
          && (
            <div style={{ padding: '10px', border: '1px solid black' }}>
              <small>
                {formatMessage(messages.newQuestionType)}
              </small>
              <div className="p-grid">
                <div className="p-col-12">
                  <Dropdown
                    value={ariType}
                    options={ariTypeOptions}
                    onChange={e => setAriType(e.target.value)}
                    placeholder={formatMessage(messages.dropdownPlaceholder)}
                  />
                </div>
                {ariType === 'TEXT'
                  && (
                    <CreateTextField
                      addGlobalAriField={addGlobalAriField}
                      currentAccount={currentAccount}
                    />
                  )}
                {ariType === 'NUMBER'
                  && (
                    <CreateNumberField
                      addGlobalAriField={addGlobalAriField}
                      currentAccount={currentAccount}
                    />
                  )
                }
                {ariType === 'DROPDOWN'
                  && (
                    <CreateDropdownField
                      addGlobalAriField={addGlobalAriField}
                      currentAccount={currentAccount}
                    />
                  )}
              </div>
            </div>
          )}
      </Panel>
    </div>
  );
};

CreateGlobalARIFields.propTypes = {
  ariTypeOptions: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  currentAccount: PropTypes.string.isRequired,
  currentFieldCount: PropTypes.number.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  maxFieldCount: PropTypes.number.isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withAccount(injectIntl(CreateGlobalARIFields));
